<template>
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
  >
    <g clip-path="url(#clip0_3694_6894)">
      <path
        d="M18.5625 13.5C18.5625 14.6707 18.4992 15.7992 18.3885 16.875H8.61152C8.50078 15.7992 8.39004 14.6707 8.39004 13.5C8.39004 12.3293 8.50078 11.2008 8.61152 10.125H18.3885C18.4992 11.2008 18.5625 12.3293 18.5625 13.5ZM26.5729 10.125C26.8523 11.2061 27 12.3346 27 13.5C27 14.6654 26.8523 15.7939 26.5729 16.875H20.0812C20.192 15.7887 20.25 14.6127 20.25 13.5C20.25 12.3398 20.192 11.2113 20.0812 10.125H26.5729ZM26.0191 8.4375H19.865C19.3377 5.06988 18.2936 2.24754 16.9488 0.445184C21.0832 1.53404 24.4371 4.53199 26.0191 8.4375ZM18.1564 8.4375H8.84355C9.16523 6.51797 9.66094 4.81887 10.2674 3.44619C10.8211 2.20113 11.4381 1.29779 12.034 0.728262C12.6246 0.16759 13.115 0 13.5 0C13.885 0 14.3754 0.16759 14.966 0.728262C15.5619 1.29779 16.1789 2.20113 16.7326 3.44619C17.3391 4.81887 17.8348 6.51797 18.1564 8.4375ZM0.981387 8.4375C2.56236 4.53199 5.9168 1.53404 10.0512 0.445184C8.70645 2.24754 7.6623 5.06988 7.13496 8.4375H0.981387ZM6.91875 10.125C6.80801 11.2113 6.70254 12.3398 6.70254 13.5C6.70254 14.6127 6.80801 15.7887 6.91875 16.875H0.425303C0.147656 15.7939 0 14.6654 0 13.5C0 12.3346 0.147656 11.2061 0.425303 10.125H6.91875ZM10.2674 23.5512C9.66094 22.1801 9.16523 20.482 8.84355 18.5625H18.1564C17.8348 20.482 17.3391 22.1801 16.7326 23.5512C16.1789 24.801 15.5619 25.7027 14.966 26.2723C14.3754 26.8313 13.885 27 13.4525 27C13.115 27 12.6246 26.8313 12.034 26.2723C11.4381 25.7027 10.8211 24.801 10.2674 23.5512ZM10.0512 26.557C5.9168 25.4654 2.56236 22.4701 0.981387 18.5625H7.13496C7.6623 21.9322 8.70645 24.7535 10.0512 26.557ZM16.9488 26.557C18.2936 24.7535 19.3377 21.9322 19.865 18.5625H26.0191C24.4371 22.4701 21.0832 25.4654 16.9488 26.557Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3694_6894">
        <rect width="27" height="27" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({ className: String });
</script>
